declare const jQuery: any;
const $ = jQuery;

export function initSliderDynamicNav(): void
{
    const $navWraps = $(".slider-item .dynamic-nav-wrap");
    if ($navWraps.length === 0)
    {
        return;
    }
    $navWraps.each(function () {
        const $navWrap = $(this);
        const $sliderItem = $navWrap.closest(".slider-item");
        const $slider = $sliderItem.closest(".slider");
        const $prevSliderItem = $sliderItem.prev(".slider-item");
        const $nextSliderItem = $sliderItem.next(".slider-item");
        const prevLabel: string = $prevSliderItem.find("[data-dynamic-nav-label]").attr("data-dynamic-nav-label");
        const nextLabel: string = $nextSliderItem.find("[data-dynamic-nav-label]").attr("data-dynamic-nav-label");
        if (prevLabel)
        {
            $navWrap.addClass("show has-prev").find(`[data-dynamic-nav="prev"]`).html(prevLabel).on("click", e => {
                $slider.trigger("slide-to-prev-item");
            }).addClass("show");
        }
        if (nextLabel)
        {
            $navWrap.addClass("show has-next").find(`[data-dynamic-nav="next"]`).html(nextLabel).on("click", e => {
                $slider.trigger("slide-to-next-item");
            }).addClass("show");
        }
    });
}
